import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';

import {
  Box,
  Typography,
  makeStyles,
  Button,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from '@material-ui/core';

import TopSection from '../common/topSection';

import { selectFeeds } from '../app/appSlice';
import { selectCurrentItemOwner } from '../itemOwner/itemOwnersSlice';
import useTitle from '../../hooks/use-title.hook';

const useStyles = makeStyles(theme => ({
  thead: {
    '& .MuiTableCell-head': {
      borderBottomColor: 'rgba(0,0,0,0.6)'
    }
  },
  row: {
    '&$tableRowHover:hover': {
      backgroundColor: theme.palette.primary[50],
      cursor: 'pointer'
    }
  },
  tableRowHover: {
    // Needed to override hover, even if it is empty
  },
}));

const FeedsPage = props => {
  const { t } = useTranslation();
  const feeds = useSelector(selectFeeds);
  const itemOwnerId = useSelector(selectCurrentItemOwner);
  const classes = useStyles();
  const history = useHistory();

  const feedsWithLinks = feeds.map(feed => {
    return {
      ...feed,
      link: `/pih/owner/${itemOwnerId}/feeds/${feed.id}`,
    };
  });

  useTitle(t('feeds:feeds'));

  return (
    <>
      <TopSection>
        <Typography variant="h4" component="h1">{t('feeds:feeds')}</Typography>
      </TopSection>

      <Box p={3.5}>
        <TableContainer>
          <Table>
            <TableHead className={classes.thead}>
              <TableRow>
                <TableCell><Typography variant="overline">{t('feeds:name')}</Typography></TableCell>
                <TableCell><Typography variant="overline">{t('feeds:contentType')}</Typography></TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {feedsWithLinks.map((feed) => (
                <TableRow key={feed.id} classes={{root: classes.row, hover: classes.tableRowHover}} hover onClick={() => history.push(feed.link)}>
                  <TableCell>{feed.name}</TableCell>
                  <TableCell>{t(`feeds:${feed.content_type}`)}</TableCell>
                  <TableCell align="right"><Button to={feed.link} component={Link} color="primary">{t('feeds:viewDetails')}</Button></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

export default FeedsPage;
